import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import {AppContext} from './Context';
import ExpertHomeContextProvider from '../screens/ExpertHome/ExpertHomeContextProvider';
// import PropTypes from "prop-types";
// import history from "./history";

export default class PrivateRoute extends React.Component {
  state = {
    isAuthorised:
      this.context.currentUser && this.context.currentUser.guest === undefined,
  };
  componentDidMount() {
    //
    this.requireAuth();
  }

  async requireAuth() {
    // let res = await this.context.authenticationService.requireAuth();

    if (this.context.currentUser.userId !== undefined) {
      // authorized!

      this.setState({isAuthorised: true});
    } else {
      this.setState({isAuthorised: false});
    }
  }
  render() {
    let {isAuthorised} = this.state;
    let {component: Component} = this.props;
    return (
      //TODOBR: Ilan/Jashan need to review
      <ExpertHomeContextProvider>
        <Route
          render={(props) =>
            isAuthorised ? (
              <Component {...props} />
            ) : (
              <Redirect
                to={{
                  pathname: '/login',
                  state: {from: props.location},
                }}
              />
            )
          }
        />
      </ExpertHomeContextProvider>
    );
  }
}

PrivateRoute.contextType = AppContext;
